import { appMode, getHaramiMockApiEndpoints } from '~/config'
import { fetchSession, getCookieValue } from './deviceAuthSession'
import type { Middleware } from '@ulysses-inc/harami_api_client'

const mockServerMiddleware: Middleware['pre'] = async ({ url, init }) => {
  if (getHaramiMockApiEndpoints().length === 0) {
    return { url, init }
  }
  const originalUrl = new URL(url)
  for (const mockEndpoint of getHaramiMockApiEndpoints()) {
    if (mockEndpoint.endsWith(originalUrl.pathname)) {
      return {
        url: mockEndpoint + originalUrl.search,
        init: {
          ...init,
          headers: {
            ...init.headers,
            'X-API-KEY': 'dummy',
          },
        },
      }
    }
  }
  return { url, init }
}

// キオスク端末アカウント (Device) セッションのトークン自動リフレッシュ。
// harami_expire_at Cookie の有効期限が近い場合、API リクエスト前にセッションを再取得する。
// 同時リクエストの多重リフレッシュは fetchSession 側の in-flight 共有で防がれる。
const deviceAuthTokenRefreshMiddleware: Middleware['pre'] = async ({
  url,
  init,
}) => {
  // キオスク端末 (kiosk) モード以外ではリフレッシュしない。
  // app モードの端末に stale な harami_expire_at Cookie が残っていた場合に、
  // fetchSession が User セッションを Device セッションで上書きしてしまう事故を防ぐ。
  if (!appMode.isKiosk) {
    return { url, init }
  }

  const gracePeriodSec = 120 // 有効期限の 120 秒前に再取得する
  const nowSec = Math.floor(Date.now() / 1000)

  const expireAt = getCookieValue('harami_expire_at')
  // デバイスセッションが無い（User 認証など）場合は何もしない
  if (!expireAt) {
    return { url, init }
  }

  const expireAtSec = parseInt(expireAt, 10)
  // 不正値（NaN）は期限不明のため、保守的にリフレッシュへ倒す（期限切れのまま API を叩かない）。
  const isExpiringSoon =
    Number.isNaN(expireAtSec) || nowSec > expireAtSec - gracePeriodSec
  if (!isExpiringSoon) {
    return { url, init }
  }

  await fetchSession()

  return { url, init }
}

const preMiddlewaresBase: Middleware['pre'][] = [
  deviceAuthTokenRefreshMiddleware,
]

if (getHaramiMockApiEndpoints().length > 0) {
  preMiddlewaresBase.push(mockServerMiddleware)
}

export const preMiddlewares: readonly Middleware['pre'][] = [
  ...preMiddlewaresBase,
]
